import Swiper from 'swiper/dist/js/swiper.js'

export default function (Site, $) {
  Site.widget('student-slider', {
    _create () {
      // this.studentSlider()
    },

    _transitionIn () {
      this.studentSlider()
      
    },

    studentSlider () {
      this.mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 2,
        spaceBetween: 22,
        slidesPerGroup: 2,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        // width: 250,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        breakpointsInverse: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 22,
            slidesPerGroup: 4,
          }
        }
      });
    }
  })
}
